module.exports = __webpack_public_path__ + "img/highly-recommended-ingredients-icon.18afce52.svg";